import React from 'react';
import clsx from 'clsx';

import styles from './modelNameRenderer.scss';

const modelNameRenderer = ({ isOpen } = {}) => ({ cellData, rowData }) => (
  <div className={styles.modelNameContainer}>
    <span className={styles.modelName}>{cellData}</span>
    {rowData.columns && (
      <span>
        <span className={styles.fieldCounter}>
          {rowData.columns && rowData.columns.length} fields
        </span>
        <span
          className={clsx(
            styles.arrow,
            isOpen ? 'icon-custom-caret-up' : 'icon-custom-caret-down',
          )}
        />
      </span>
    )}
  </div>
);

export default modelNameRenderer;
